import { ConnectorStages } from 'src/products/connector/constants';

export const insertStageParamUrl = (stage?: string) => {
  const search = window.location.search.replace('?', '');

  if (!search || !stage) {
    const decoded = btoa(JSON.stringify({ stage: ConnectorStages.PUBLISH }));
    window.history.pushState('', '', `?${decoded}`);
    return;
  }

  const uncoded = atob(decodeURIComponent(search));
  const searchParams = JSON.parse(uncoded);
  searchParams.stage = stage;

  const decoded = btoa(JSON.stringify(searchParams));

  window.history.pushState('', '', `?${decoded}`);
};
